import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
export const prefix = 'funds';
export const prefixWithSeparator = prefix + SEPARATOR;
export const wildcardName = prefixWithSeparator + '-';
export const IDToName = ({ fundID }) => {
    return prefixWithSeparator + fundID;
};
export const validateName = genericValidateName([exactValidator(prefix), uuidValidator()]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split(SEPARATOR);
    return { fundID: parts[1] };
};
